module.exports = __webpack_public_path__ + "img/circle-cross.7b8b82ba.svg";